import RouterPurls from "./router";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./router/errorControler";
import './scss/main.scss'
import { AuthProvider } from "./provider/AuthProvider";
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <RouterPurls />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App;
